import React from 'react';
import PropTypes from 'prop-types';

import styles from './avatar.scss';
import classNames from '../../utils/classNames';
import { getGradientByText } from './gradients';

export default function Avatar(props) {
    function getFirstLetter() {
        if (props.text !== undefined) {
            return props.text.toUpperCase().replace(/\W+_/g, '')[0] || '';
        }

        return '';
    }

    function getAvatarColor() {
        return getGradientByText(props.text);
    }

    const classes = classNames(styles.wrapper, {
        [styles.medium]: props.size === 'm',
    });

    return (
        <div className={classes} style={{ background: getAvatarColor() }}>
            <span>{getFirstLetter()}</span>
        </div>
    );
}

Avatar.propTypes = {
    /**
     * Text related to the avatar.
     * The first letter of the text will be used for the avatar.
     */
    text: PropTypes.string,
    size: PropTypes.oneOf(['s', 'm']),
};
